//@flow
import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Input from 'common/components/core/input';
import Dropdown from './Dropdown';
import { Box } from '@locus-taxy/neo-ui';
import { Select } from 'common/components/core/select';
import DateTimePicker from './DateTimePicker';
import Autocomplete from 'common/components/core/autocomplete';
import { OutlineCheckbox } from './Checkbox';
import Switch from 'common/components/core/switch';
import popOverFactory from 'common/components/core/popover/popOverFactory';
import { enhancedFieldFactory } from './EnhancedFieldFactory';

class Field extends Component {
    static propTypes = {
        onChange: PropTypes.func,
        label: PropTypes.string,
        theme: PropTypes.object,
        value: PropTypes.any,
        leftIcon: PropTypes.any,
        rightIcon: PropTypes.any,
        placeholder: PropTypes.string,
        type: PropTypes.string,
        multiline: PropTypes.bool,
        invert: PropTypes.bool
    };

    onChange = (...args) => {
        this.props.onChange ? this.props.onChange(...args) : null;
    };

    getField = element => {
        var {
            onChange, //eslint-disable-line no-unused-vars
            label,
            theme,
            value,
            checked,
            leftIcon,
            rightIcon,
            placeholder,
            template,
            error,
            info,
            bottomText,
            invert,
            ...others
        } = this.props;
        if (element === 'input') {
            return (
                <Input
                    {...others}
                    floating={false}
                    theme={theme}
                    label={label}
                    onChange={this.onChange}
                    value={value}
                    placeholder={placeholder}
                    invert={invert}
                    rightIcon={rightIcon}
                    leftIcon={leftIcon}
                    error={error}
                    info={info}
                    bottomText={bottomText}
                />
            );
        } else if (element === 'datetime-kronos') {
            return (
                <DateTimePicker
                    {...others}
                    placeholder={placeholder}
                    label={label}
                    value={value}
                    preventClickOnDateTimeOutsideRange
                    onChange={this.onChange}
                    theme={theme}
                    error={error}
                    info={info}
                />
            );
        } else if (element === 'dropdown') {
            return (
                <Dropdown
                    {...others}
                    placeholder={placeholder}
                    theme={theme}
                    onChange={this.onChange}
                    label={label}
                    value={value}
                    template={template}
                    error={error}
                />
            );
        } else if (element === 'autocomplete') {
            return (
                <Autocomplete
                    {...others}
                    placeholder={placeholder}
                    theme={theme}
                    label={label}
                    value={value}
                    onChange={this.onChange}
                    template={template}
                    error={error}
                />
            );
        } else if (element === 'checkbox') {
            return (
                <OutlineCheckbox
                    {...others}
                    theme={theme}
                    label={label}
                    checked={checked}
                    onChange={this.onChange}
                />
            );
        } else if (element === 'switch') {
            return (
                <Switch
                    {...others}
                    theme={theme}
                    label={label}
                    checked={checked}
                    onChange={this.onChange}
                />
            );
        } else if (element === 'select') {
            const { source, width } = others;
            return (
                <Box width={width}>
                    <Select
                        selectSize="medium"
                        placeholder={placeholder}
                        options={source}
                        theme={theme}
                        className={theme.statusSelect}
                        onChange={this.onChange}
                        portal
                        isClearable={false}
                        noMarginBottom
                        openMenuOnFocus
                    />
                </Box>
            );
        }
    };

    render() {
        const { element, theme, className, children } = this.props;
        var renderedField = this.getField(element);
        return (
            <div
                className={classnames(
                    theme.field,
                    theme[`${element}Field`],
                    className
                )}
                data-react-toolbox="field"
            >
                {renderedField}
                {children}
            </div>
        );
    }
}

const FieldWithPopover = popOverFactory({ Component: Field });

const EnhancedFieldWithObserver = enhancedFieldFactory({
    FieldComponent: FieldWithPopover
});
export {
    Field,
    EnhancedFieldWithObserver as EnhancedField,
    enhancedFieldFactory
};
export default Field;
